const cn = {
  "User": "用户名",
  "Password": "密码",
  "Login": "登录",
  "Oversea Return Service": "海外本地退",
  "Save": "保存",
  "Order ID": "淘宝订单号",
  "Order ID(optional)": "淘宝订单号(选填)",
  "Delivery tracking number(optional)": "快递单号(选填)",
  "Delivery tracking number": "快递单号",
  "Notes": "备注(选填)",
  "Upload Image": "上传照片",
  "Product Images": "产品照片*",
  "Is product damaged?": "商品是否破损?",
  "Yes": "是",
  "No": "否",
  "Warehouse": "仓库",
  "Merchant": "商家",
  "Latest return requests": "最近的退货请求",
  "requested": "请求成功",
  "Requested": "请求成功",
  "Create a new return request": "发起退货",
  "Warehouse Location": "退货仓地址",
  "Return Details": "退货详情",
  "New return request": "新的退货",
  "Pick a warehouse": "请选择退货仓库",
  "Quantity": "数量",
  "Return Quantity": "退还数量",
  "Actual paid amount": "实际支付金额",
  "refund": "应退款",
  "Delete": "删除",
  "Returned": "已退回",
  "Refunded": "已退款",
  "Warehouse Records": "仓库记录",
  "Back": "返回",
  "Customer service": "客服",
  "Incomplete returns": "未完成的退货",
  "Warehouse record": "仓库记录",
  "This record doesn't have a match in any return request": "没有找到和此记录有关的退货请求",
  "Link to": "链接去退货请求",
  "Product name": "商品名称",
  "Product descripotion": "商品描述",
  "Product ID": "商品ID",
  "Sorry. You don't have permission to access this page.": "抱歉，您没有查看此页的权限",
  "No Permission": "无权限",
  "New return item": "新退货",
  "Return items": "商品清单",
  "Close": "关闭",
  "Save changes": "保存",
  "Cancel delete": "取消删除",
  "You don't have any return requests": "您还没有任何退货请求",
  "user does not exist": "用户不存在",
  "Error": "失败",
  "Success": "成功",
  "Please fill the correct information!": "请输入正确的信息！",
  "Result not found": "找不到相关退货请求",
  "Changes has been saved": "保存成功",
  "Warehouse Record created!": "仓库信息创建成功!",
  "Please upload at least one image!": "请至少上传一张退货照片!",
  "congratulations! No incomplete return requests!": "恭喜你，没有任何未处理完成的退货，再接再厉~",
  "Received at warehouse": "仓库已收到货",
  "Issued refund": "已经退款完成",
  "returned": "仓库已收到货",
  "refunded": "已经退款完成",
  "Approve": "同意退款",
  "approved": "同意退款",
  "Item not found!": "找不到该退货",
  "This item is damaged": "此退货有破损",
  "This item is in good condition": "此退货没有破损",
  "Logout": "登出",
  "Changes has been saved!": "更改保存成功!",
  "password not match": "密码不正确!",
  "Please key in a valid Taobao order id.": "请输入正确的淘宝订单编号！",
  "Page not found!": "找不到该页面！",
  "Do you confirm to delete this record?": "确定要删除本条记录吗？",
  "No warehouse records yet. Be patient.": "还没有收到任何仓库记录，请耐心等待。",
  "Store Id: {n}": "店铺ID: {n}",
  "Home": "主页",
  "Welcome!": "欢迎!",
  "Taobao order id": "淘宝订单编号",
  "Not saved": "未保存",
  "Edit": "修改",
  "Created Date": "创建时间",
  "Taobao ID": "淘宝ID",
  "Taobao order ID already exist": "淘宝订单编号已经存在，请修改已有订单",
  "Decline": "拒绝退款",
  "decline": "拒绝退款",
  "Change status to": "改变退货状态",
  "Change password": "更改密码",
  "Current password": "当前密码",
  "New password": "新密码",
  "Repeat new password": "请重新输入新密码",
  "Fields cannot be empty!": "请将信息填写完整!",
  "New password doesn't match!": "两次填写的新密码不一致",
  "Change password failed": "密码修改失败",
  "Internal Server Error": "服务器错误, 请联系客服",
  "Successfully updated your password!": "密码更改成功！",
  "New password cannot be the same as current password!": "新密码不能和现在的密码相同！",
  "Something went wrong.": "出错了, 请联系客服",
  "Passwords must be at least 8 characters long!": "密码长度必须大于或等于8位！",
  "Comments": "备注",
  "Comment": "留言",
  "commented on": "发布于",
  "Send to merchant": "发送给商家",
  "Confirm send this image to the merchant?": "确定发送此图片给商家吗？",
  "Comment cannot be empty!": "留言不能是空的！",
  "taobao": "淘宝",
  "zhongan": "众安",
  "slab": "SLab",
  "Start Date": "开始日期",
  "End Date": "结束日期",
  "Please pick a date": "请选择日期",
  "Taobao Status": "退货状态",
  "Taobao Return Warehouse Id": "海外退货仓ID",
  "Taobao Parent Order Id": "淘宝父订单号",
  "Taobao Return Tracking Number": "运单号",
  "Taobao Claim Number": "理赔单号",
  "Please choose": "请选择",
  "Search query or start date and end date must not be empty!": "搜索栏或者开始日期和结束日期至少要填写一个！",
  "created": "请求成功",
  "Created": "请求成功",
  "Not Received": "未收到货",
  "Affect resell": "影响二次销售",
  "Received in good condition": "品质完好",
  "Received wrong item": "退回商品与描述不符",
  "All": "全部",
  "Return status": "退货状态",
  "Please choose a status": "请选择一个退货状态",
  "Please select": "请选择",
  "Claim": "理赔",
  "Update": "更新",
  "Policy Id": "信安内部单号",
  "Taobao Order Id": "淘宝订单编号",
  "Store Name": "店铺名称",
  "Submitted on": "提交时间",
  "Coverage": "保障",
  "Category": "品类",
  "Product Name": "商品名称",
  "Unit Price": "单价",
  "Order Date": "订单日期",
  "Product Property": "商品属性",
  "Update": "更新",
  "Status": "状态",
  "Delivery Tracking Number": "快递单号",
  "Claim Number": "理赔单号",
  "Return Reason": "退货原因",
  "Return Remarks": "退货备注",
  "Updated successfully": "更新成功",
  "Merchant Name": "店铺名称",
  "Parent Order Id": "父订单号",
  "Suborder Id": "子订单号",
  "Product Name": "商品名称",
  "Unit Price": "商品单价(CNY)",
  "Delivery tracking number": "快递单号",
  "Claim Amount": "理赔金额(CNY)",
  "Claim Status": "理赔状态",
  "No records has been found! Please choose another date or use another id.": "没有找到任何相关信息，请选择其他日期或者搜索其他单号。",
  "Return records": "退货记录",
  "Paid Amount": "实际支付金额",
  "The date range must be within 70 days!": "搜索的范围必须在70天内",
  "Return Submitted Date": "发起退货时间",
  "Order Created at": "订单创建时间",
  "resell": "转卖",
  "Axinan Internal Product Id": "信安内部商品ID",
  "Stock In": "入库",
  "Search": "搜索",
  "We haven't receive any data about this package! Please check a few days later!": "我没还没有收到这件包裹的信息，请改天再尝试！",
  "Please key in the delivery tracking number on the package.": "请输入包裹上的快递单号。",
  "Note": "提示",
  "Create New Inventory Item": "创建仓库记录",
  "Inventory Items": "创建仓库",
  "unreceived packages": "未收到的退货",
  "Scan": "掃碼",
  "Create Staging Record": "創建臨時倉儲信息",
  "We can't find this tracking number in our system, please create a staging record first!": "在系統中找不到這個快遞單號，請先創建一個臨時的倉儲信息！",
  "Tracking Number": "快遞單號",
  "Shelf Id": "貨架代碼",
  "Customer Name": "顧客姓名",
  "Customer Phone Number": "顧客電話",
  "Staging Records": "臨時倉儲信息",
  "Received without info": "没有收到退貨信息",
  "Ready to stock in": "等待入庫",
  "Completed": "已完成",
  "Price": "金额",
  "lastUpdateAt": "上次更新于",
  "20": "用户不存在",
  "21": "用户名与密码不匹配",
  "22": "没有权限访问",
  "23": "登录失败",
}

export default cn



// WEBPACK FOOTER //
// ./src/translations/cn.js